import { render, staticRenderFns } from "./TreatmentArchivesList.vue?vue&type=template&id=178fc8d2&scoped=true&"
import script from "./TreatmentArchivesList.vue?vue&type=script&lang=js&"
export * from "./TreatmentArchivesList.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentArchivesList.vue?vue&type=style&index=0&id=178fc8d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178fc8d2",
  null
  
)

export default component.exports